import { createApp } from 'vue'
import App from './App.vue'
import { registerPlugins } from './plugins/app-plugins'
import { handleGlobalErrors } from './utils/global-error-handler'

const app = createApp(App)

registerPlugins(app)
handleGlobalErrors(app)

app.mount('#app')
